import React from 'react';
import '../../public/css/PartTime.css';

function PartTime() {
    return (
        <div className='cv'>
            <div className='header'>
                <h1>Jun Hyeong Yang</h1>
                <p>Dublin 7, Dublin County, Ireland &nbsp;▪&nbsp; 083-090-2821 &nbsp;▪&nbsp; y.junh0y@gmail.com</p>
            </div>
            <div className='content'>
                <div className='each'>
                    <p className='title'>Personal Summary</p>
                    <ul className='description'>
                        <div className="eachDescription">
                            <div className="main">
                                <p>&nbsp;A highly dedicated and adaptable individual with extensive part-time experience in the food and beverage industry. Skilled in preparing a variety of dishes and beverages, providing excellent customer service, and efficiently managing tasks across different shifts. Demonstrated ability to communicate effectively with a diverse, international customer base using English.</p>
                            </div>
                            <div className="main">
                                <p>&nbsp;Having visited Dublin 8 years ago, I was captivated by the city's vibrant culture and friendly atmosphere. This positive experience has motivated me to return and seek a part-time position where I can apply my culinary and service skills while contributing to a dynamic team environment.</p>
                            </div>
                        </div>
                    </ul>
                </div>
                <div className='each'>
                    <p className='title'>Education</p>
                    <div className='description'>
                         <div className="eachDescription">
                            <div className='main'>
                                <div className="info">
                                    <span>KOSMO</span>
                                    <span>Seoul, South Korea</span>
                                </div>
                                <div className='date'>
                                    <span>SEP 2021 - MAR 2022</span>
                                </div>
                            </div>
                            <div className='sub'>
                                <ul>
                                    <li>Completed the JAVA Full Stack Expert Training Program.</li>
                                </ul>
                            </div>
                        </div>
                        <div className="eachDescription">
                            <div className='main'>
                                <div className="info">
                                    <span>Hongik University</span>
                                    <span>Seoul, South Korea</span>
                                </div>
                                <div className='date'>
                                    <span>MAR 2010 - FEB 2017</span>
                                </div>
                            </div>
                            <div className='sub'>
                                <ul>
                                    <li>Bachelor of Mechanical System Design Engineering</li>
                                    <li>Minor of Ceramic & Glass</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='each'>
                    <p className='title'>Work Experience</p>
                    <div className='description'>
                        <div className="eachDescription">
                            <div className='main'>
                                <div className="info">
                                    <span>Travel Maker</span>
                                    <span>Brunch Cafe Staff (Weekend Parttime)</span>
                                    <span>Seoul, South Korea</span>
                                </div>
                                <div className='date'>
                                    <span>JAN 2019 - MAY 2024</span>
                                </div>
                            </div>
                            <div className='sub'>
                                <ul>
                                    <li>Prepared a variety of brunch dishes, including hash browns, eggs, sausages, bacon, pancakes, french toast, waffles, and more</li>
                                    <li>Crafted various beverages such as coffee, shakes, ades, and teas</li>
                                    <li>Handled customer orders and provided efficient table service</li>
                                    <li>Worked across all shifts, including opening, midday, and closing</li>
                                    <li>Utilized English regularly to communicate with a predominantly international customer base</li>
                                </ul>
                            </div>
                        </div>
                        <div className="eachDescription">
                            <div className='main'>
                                <div className="info">
                                    <span>CTK</span>
                                    <span>Developer (Permanent)</span>
                                    <span>Seoul, South Korea</span>
                                </div>
                                <div className='date'>
                                    <span>APR 2022 - APR 2024</span>
                                </div>
                            </div>
                            <div className='sub'>
                                <ul>
                                    <li>Developed and maintained web applications using PHP, Laravel, and vue.js</li>
                                    <li>Collaborated with UI/UX designers to enhance user experience</li>
                                </ul>
                            </div>
                        </div>
                        <div className="eachDescription">
                            <div className='main'>
                                <div className="info">
                                    <span>Innerbottle</span>
                                    <span>Enginneer (Permanent)</span>
                                    <span>Gyengki, South Korea</span>
                                </div>
                                <div className='date'>
                                    <span>JUN 2019 - JUN 2021</span>
                                </div>
                            </div>
                            <div className='sub'>
                                <ul>
                                    <li>Planned and designed eco-friendly cosmetic packaging</li>
                                    <li>Managed production processes and developed manufacturing technologies</li>
                                    <li>Conducted compatability testing and performed quality control tasks</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='each'>
                    <p className='title'>Skills</p>
                    <div className='description'>
                        <div className="eachDescription">
                            <div className='main'>
                                <div className="info">
                                    <span>Language</span>
                                </div>
                            </div>
                            <div className='sub'>
                                <ul>
                                    <li>Korean (Native), English (Intermediate)</li>
                                </ul>
                            </div>
                        </div>
                        <div className="eachDescription">
                            <div className='main'>
                                <div className="info">
                                    <span>Programming</span>
                                </div>
                            </div>
                            <div className='sub'>
                                <ul>
                                    <li>HTML, CSS, JavaScript, jQuery, PHP, Laravel, vue.js, React</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        
    )
}

export default PartTime